import * as React from "react";
import { ContractNoteLocked } from "../../../assets/svg/ContractNoteLocked";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var GridItemContainerContractNotAvailable = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement(SvgButton, { name: IdStyles.MarketGridItemContractNotAvailable, svg: ContractNoteLocked, className: className, onClick: onClick }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerContractNotAvailable.tsx
// module id = 2723
// module chunks = 3